import { React, useState, useEffect } from 'react';
import CountUp from 'react-countup';
import useStorage from '../../../../utils/useStorage';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Editable from 'react-editable-title';
import DeleteIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import { emptyObject } from '../../../../utils/utils';
import useApi from '../../../../utils/useApi';
import PrintPreviewModal from '../../Print/PrintPreviewModal';
import { isSessionStale } from '../sessionUtils';
import './sessionCard.css';

const SessionCard = (children) => {
  const { data, handleModalSale, setOldValues, refreshCards } = children;
  const {
    session_id: sessionId,
    identifier,
    sale_metadata: saleMetadata,
    oldValue,
    id,
    responsible,
  } = data;
  const [modalExclude, setModelExclude] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [textTitle, setTextTitle] = useState(identifier);
  const [textTiny, setTextTiny] = useState(responsible);
  const [credencials] = useStorage('userAcess');

  useEffect(() => {
    setTextTitle(identifier);
  }, [identifier]);

  useEffect(() => {
    setTextTiny(responsible);
  }, [responsible]);

  const handlePrintClick = (e) => {
    e.stopPropagation();
    setModalPrint(true);
  };

  const handleClosePrintModal = () => {
    setModalPrint(false);
  };

  const [salesLoad] = useApi({
    method: 'put',
    url: '/sales/sessions',
  });

  const [sessionDelete] = useApi({
    method: 'delete',
    url: '/sales/sessions',
  });

  const deleteSession = () => {
    sessionDelete({
      data: emptyObject({ session_id: sessionId }),
      onCompleted: () => {
        refreshCards({});
      },
    });
  };

  const handleModalExclude = () => {
    setModelExclude(!modalExclude);
  };

  const handleTextTitleUpdate = (current) => {
    if (current !== textTitle) {
      setTextTitle(current);
      salesLoad({
        data: emptyObject({ session_id: sessionId, identifier: current }),
        onCompleted: () => {
          refreshCards({});
        },
      });
    }
  };

  const handleTextTinyUpdate = (current) => {
    if (current !== textTiny) {
      setTextTiny(current);
      salesLoad({
        data: emptyObject({ session_id: sessionId, responsible: current }),
        onCompleted: () => {
          refreshCards({});
        },
      });
    }
  };

  const isStale = isSessionStale(data, 14);
  const cardStatusClass = isStale ? 'sessions-card__card--stale' : '';

  return (
    <div className={`sessions-card__card ${cardStatusClass}`} onClick={() => handleModalSale(data)}>
      {isStale && (
        <span className="sessions-card__corner-tag sessions-card__corner-tag--stale" title="Comanda sem atualização há mais de 14 dias">
          ⚠️ +14d
        </span>
      )}
      <Typography className="sessions-card__title">
        <span onClick={(e) => e.stopPropagation()}>
          <Editable
            key={`title-${sessionId || id}-${identifier}`}
            text={textTitle}
            placeholder="Nome"
            cb={handleTextTitleUpdate}
            className="sessions-card__title"
          />
        </span>
      </Typography>
      <Typography className="sessions-card__tranfer">
        <span onClick={(e) => e.stopPropagation()}>
          <Editable
            key={`resp-${sessionId || id}-${responsible}`}
            style={{ fontWeight: 1000 }}
            text={textTiny}
            placeholder="Funcionário"
            cb={handleTextTinyUpdate}
          />
        </span>
      </Typography>
      <Typography
        noWrap
        className="sessions-card__money"
      >
        <span>
          <CountUp
            startOnMount
            decimals={2}
            decimal=","
            prefix="R$ "
            end={saleMetadata.total}
            start={oldValue}
            duration={2}
            onEnd={() => {
              if (Number(oldValue) !== Number(saleMetadata.total))
                setOldValues(id, saleMetadata.total);
            }}
          />
        </span>
      </Typography>
      <div className="sessions-card__actions" onClick={(e) => e.stopPropagation()}>
        <Button
          onClick={handlePrintClick}
          color="primary"
          autoFocus
          startIcon={<PrintIcon />}
        >
          Imprimir
        </Button>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<DeleteIcon />}
          onClick={() => handleModalExclude()}
        />
      </div>
      <Dialog
        open={modalExclude}
        onClose={handleModalExclude}
        onClick={(e) => e.stopPropagation()}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Cancelar Comanda
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja encerrar e apagar essa comanda?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleModalExclude} color="primary">
            Voltar
          </Button>
          <Button onClick={deleteSession} color="secondary">
            Apagar
          </Button>
        </DialogActions>
      </Dialog>
      <PrintPreviewModal
        open={modalPrint}
        handleClose={handleClosePrintModal}
        saleData={data}
        credencials={credencials}
        options={{}}
      />
    </div>
  );
};

export default SessionCard;
